import AxiosHandler from "@/assets/js/class/AxiosHandler.js"
import ReservaController from "@/assets/js/class/ReservaController.js"
import PassportHandler from "@/assets/js/class/PassportHandler.js"

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue) {
    this.appendAxiosHandler(Vue)
    this.appendPassportHandler(Vue)
    this.apeendReservaController(Vue)
  },
  appendAxiosHandler(Vue) {
    Vue.prototype.$axiosHandlerAs = new AxiosHandler(Vue.$loading)
  },
  apeendReservaController(Vue) {
    Vue.prototype.$reservaControllerAs = new ReservaController(
      Vue.prototype.$axiosHandlerAs,
      Vue.prototype.$passporthandler
    )
  },
  appendPassportHandler(Vue) {
    Vue.prototype.$passporthandler = new PassportHandler(Vue.prototype.$axiosHandlerAs)
  }
}
